import { useJourneyStore } from "../game/state/journeyMachine";
import { QualitySelector } from "./QualitySelector";

export function TopBar() {
  const screen = useJourneyStore((s) => s.screen);
  const setHelpOpen = useJourneyStore((s) => s.setHelpOpen);
  const setSourcesOpen = useJourneyStore((s) => s.setSourcesOpen);
  const resetJourney = useJourneyStore((s) => s.resetJourney);

  return (
    <header className="flex items-center justify-between gap-4 border-b border-[var(--cale-border)] bg-[var(--cale-surface-raised)] px-4 py-2">
      <div className="flex items-center gap-3">
        {screen === "recorrido" && (
          <button
            type="button"
            onClick={resetJourney}
            className="rounded-md px-2 py-1 text-sm text-[var(--cale-accent)] hover:bg-[var(--cale-surface)]"
          >
            ← Portada
          </button>
        )}
        <span className="text-sm font-semibold">CALE · Gemelo Digital Educativo</span>
      </div>
      <div className="flex items-center gap-2">
        <QualitySelector />
        <button
          type="button"
          onClick={() => setSourcesOpen(true)}
          className="rounded-md border border-[var(--cale-border)] px-2 py-1 text-sm hover:bg-[var(--cale-surface)]"
        >
          Fuentes
        </button>
        <button
          type="button"
          onClick={() => setHelpOpen(true)}
          aria-label="Abrir ayuda"
          className="rounded-md border border-[var(--cale-border)] px-2 py-1 text-sm hover:bg-[var(--cale-surface)]"
        >
          Ayuda
        </button>
      </div>
    </header>
  );
}
